module.exports = __webpack_public_path__ + "img/svg/matches.3ce70d4210111b8945d976ec76d7ab26.svg";